import { render, staticRenderFns } from "./AlternativeDetailsDialog.vue?vue&type=template&id=051a2713"
import script from "./AlternativeDetailsDialog.vue?vue&type=script&lang=ts"
export * from "./AlternativeDetailsDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports